import { render, staticRenderFns } from "./dormRoom.vue?vue&type=template&id=f85a98f4&"
import script from "./dormRoom.vue?vue&type=script&lang=js&"
export * from "./dormRoom.vue?vue&type=script&lang=js&"
import style0 from "./dormRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports